import { DialogTitle, DialogContent, Dialog } from "@mui/material";
import { useTranslation } from "react-i18next";
import { isEmpty } from "@duosoftbg/nacid-components";
import useAppSelector from "../../../../../../../hooks/redux/base/useAppSelector";
import { homePageCategorySection } from "../../../../../../../utils/constants";
import useAppDispatch from "../../../../../../../hooks/redux/base/useAppDispatch";
import { closeEditModal } from "../../../../../../../store/redux/slice/ComponentsControl/homePageCategoryControl";
import EditCategoryLinkDialogBody from "./EditCategoryLinkDialogBody";

const EditCategoryLinkDialog = () => {
  const dispatch = useAppDispatch();

  const { open, object } = useAppSelector((state) => {
    return state.ComponentsControl.homePageCategoryControl.sections[homePageCategorySection.link].modals.edit;
  });

  const handleCloseDialog = () => {
    dispatch(closeEditModal({ section: homePageCategorySection.link }));
  };

  const { t } = useTranslation();
  const isEditMode = !isEmpty(object.id);

  return (
    <div>
      <Dialog
        PaperProps={{ sx: { position: "fixed", top: "10%", m: 0 } }}
        open={open}
        fullWidth={true}
        maxWidth={"lg"}
        onClose={() => handleCloseDialog()}
        aria-labelledby="home-page-category-link-edit-dialog-title"
      >
        <DialogTitle id="home-page-category-link-edit-dialog-title" style={{ textAlign: "center" }}>
          {!isEditMode && t("t.homePageCategoryLink.create.dialog")}
          {isEditMode && t("t.homePageCategoryLink.edit.dialog")}
        </DialogTitle>
        <DialogContent>
          <EditCategoryLinkDialogBody link={object} setOpen={handleCloseDialog} isEditMode={isEditMode} />
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default EditCategoryLinkDialog;
